import React, { useCallback, useMemo } from 'react';

import { useCarouselCardSize } from '../../hooks/use-desktop-carousel';
import { TiledGroup, tiledGroupKey, toCheckerboardGroups } from '../../utils/tiled-groups';
import { CasinoLayoutProps } from '../../utils/utils';
import { DesktopCarousel } from './DesktopCarousel';
import { TiledGroupCard } from './TiledGroupCard';

const VISIBLE_GROUPS = 4;

export const DoubleRowHeroLayout = ({ data, layoutHeaderProps }: CasinoLayoutProps) => {
    const groupSize = useCarouselCardSize(VISIBLE_GROUPS);

    const groups = useMemo(() => toCheckerboardGroups(data, 1), [data]);

    const renderItem = useCallback(
        ({ item }: { item: TiledGroup }) => <TiledGroupCard group={item} groupSize={groupSize} />,
        [groupSize]
    );

    return (
        <DesktopCarousel
            data={groups}
            itemWidth={groupSize}
            visibleCount={VISIBLE_GROUPS}
            keyExtractor={tiledGroupKey}
            renderItem={renderItem}
            layoutHeaderProps={layoutHeaderProps}
        />
    );
};
